import React, { useEffect } from 'react';
import { Grid } from '@material-ui/core';

import PageTemplate from '../../common/page-template/PageTemplate';
import PageTemplateDashboard from '../../common/page-template/PageTemplateDashboard';
import PageTemplateHeader from '../../common/page-template/PageTemplateHeader';
import OrganizationInfoCard from './cards/OrganizationInfoCard';
import { useGetOrganizationInfo } from './Organization.hooks';

const OrganizationDetailPage: React.FC = () => {
  const { organizationInfo, isLoading, error, getOrganizationInfo } =
    useGetOrganizationInfo();

  useEffect(() => {
    getOrganizationInfo();
  }, [getOrganizationInfo]);

  return (
    <PageTemplate>
      <PageTemplateHeader>
        <h2>Organization</h2>
      </PageTemplateHeader>
      <PageTemplateDashboard>
        <Grid container spacing={3}>
          <Grid item xs={12} md={8}>
            <Grid container spacing={3}>
              <Grid item xs={12}>
                <OrganizationInfoCard
                  error={error}
                  isLoading={isLoading}
                  value={organizationInfo}
                />
              </Grid>
            </Grid>
          </Grid>
        </Grid>
      </PageTemplateDashboard>
    </PageTemplate>
  );
};

export default OrganizationDetailPage;
